import { render, staticRenderFns } from "./registerItem.vue?vue&type=template&id=c4e480ce&scoped=true&"
import script from "./registerItem.vue?vue&type=script&lang=js&"
export * from "./registerItem.vue?vue&type=script&lang=js&"
import style0 from "./registerItem.vue?vue&type=style&index=0&id=c4e480ce&scoped=true&lang=scss&"
import style1 from "./registerItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e480ce",
  null
  
)

export default component.exports